webpackJsonp([178654378430483],{

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _file = __webpack_require__(643);
	
	var _file2 = _interopRequireDefault(_file);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Files = function Files(_ref) {
	  var files = _ref.files;
	
	  return files && files.length > 0 && _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "h2",
	      { className: "title" },
	      "Attachments"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "columns" },
	      files.map(function (f) {
	        return _react2.default.createElement(
	          "div",
	          {
	            className: "column is-one-fifth box has-text-centered",
	            key: f.file
	          },
	          _react2.default.createElement(
	            "a",
	            { href: f.file },
	            _react2.default.createElement(
	              "figure",
	              { className: "image container is-128x128" },
	              _react2.default.createElement("img", { src: _file2.default })
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                f.name
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "is-size-7" },
	              f.file.replace('/img/', '')
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = Files;
	module.exports = exports["default"];

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNjAgNjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYwIDYwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBkPSJNNDIuNSwyMmgtMjVjLTAuNTUyLDAtMSwwLjQ0Ny0xLDFzMC40NDgsMSwxLDFoMjVjMC41NTIsMCwxLTAuNDQ3LDEtMVM0My4wNTIsMjIsNDIuNSwyMnoiLz4NCgk8cGF0aCBkPSJNMTcuNSwxNmgxMGMwLjU1MiwwLDEtMC40NDcsMS0xcy0wLjQ0OC0xLTEtMWgtMTBjLTAuNTUyLDAtMSwwLjQ0Ny0xLDFTMTYuOTQ4LDE2LDE3LjUsMTZ6Ii8+DQoJPHBhdGggZD0iTTQyLjUsMzBoLTI1Yy0wLjU1MiwwLTEsMC40NDctMSwxczAuNDQ4LDEsMSwxaDI1YzAuNTUyLDAsMS0wLjQ0NywxLTFTNDMuMDUyLDMwLDQyLjUsMzB6Ii8+DQoJPHBhdGggZD0iTTQyLjUsMzhoLTI1Yy0wLjU1MiwwLTEsMC40NDctMSwxczAuNDQ4LDEsMSwxaDI1YzAuNTUyLDAsMS0wLjQ0NywxLTFTNDMuMDUyLDM4LDQyLjUsMzh6Ii8+DQoJPHBhdGggZD0iTTQyLjUsNDZoLTI1Yy0wLjU1MiwwLTEsMC40NDctMSwxczAuNDQ4LDEsMSwxaDI1YzAuNTUyLDAsMS0wLjQ0NywxLTFTNDMuMDUyLDQ2LDQyLjUsNDZ6Ii8+DQoJPHBhdGggZD0iTTM4LjkxNCwwSDYuNXY2MGg0N1YxNC41ODZMMzguOTE0LDB6IE0zOS41LDMuNDE0TDUwLjA4NiwxNEgzOS41VjMuNDE0eiBNOC41LDU4VjJoMjl2MTRoMTR2NDJIOC41eiIvPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.researchPostQuery = exports.ResearchPostTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(17);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Files = __webpack_require__(323);
	
	var _Files2 = _interopRequireDefault(_Files);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResearchPostTemplate = exports.ResearchPostTemplate = function ResearchPostTemplate(_ref) {
	  var content = _ref.content,
	      contentComponent = _ref.contentComponent,
	      files = _ref.files;
	
	  var PostContent = contentComponent || _Content2.default;
	  return _react2.default.createElement(
	    "div",
	    { className: "container" },
	    _react2.default.createElement(
	      "div",
	      { className: "columns" },
	      _react2.default.createElement(
	        "div",
	        { className: "column is-10 is-offset-1" },
	        _react2.default.createElement(PostContent, { className: "content", content: content }),
	        _react2.default.createElement(_Files2.default, { files: files })
	      )
	    )
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var post = data.markdownRemark;
	  var _data$markdownRemark$ = data.markdownRemark.frontmatter,
	      title = _data$markdownRemark$.title,
	      subtitle = _data$markdownRemark$.subtitle,
	      headerImage = _data$markdownRemark$.headerImage,
	      files = _data$markdownRemark$.files;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Header2.default, { title: title, subtitle: subtitle, image: headerImage }),
	    _react2.default.createElement(ResearchPostTemplate, {
	      content: post.html,
	      contentComponent: _Content.HTMLContent,
	      files: files
	    })
	  );
	};
	
	var researchPostQuery = exports.researchPostQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-research-post-js-bdba568484be2845a37b.js